<template>
  <nav class="p-4 text-white flex justify-between items-center navigation">
    <!-- Home link now on the leftmost side -->
    <router-link to="/" class="hover:text-blue-300">Home</router-link>
    
    <!-- Displayed if user is authenticated -->
    <div v-if="currentUser" class="relative inline-block" ref="dropdownContainer">
      <!-- User's profile picture -->
      <img :src="currentUser.photoURL" alt="User's Profile Image" class="h-8 w-8 rounded-full inline-block mr-2" />

      <!-- User's name button -->
      <button @click="toggleDropdown" class="relative z-10">
        {{ currentUser.displayName || currentUser.email }}
      </button>

      <div v-if="showDropdown" class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20">
        <!-- The dropdown for logout -->
        <button @click="logout" class="w-full text-left px-4 py-2 text-black hover:bg-blue-200 rounded">
          Logout
        </button>
        <router-link to="/account" >
          <button class="w-full text-left px-4 py-2 text-black hover:bg-blue-200 rounded">
            Account
          </button>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted } from 'vue';
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { useRouter } from 'vue-router';

export default {
  name: "NavbarComponent",
  setup() {
    const showDropdown = ref(false);
    const currentUser = ref(null);
    const router = useRouter();
    const dropdownContainer = ref(null);

    const handleClickOutside = (event) => {
      if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
        showDropdown.value = false;
      }
    };

    onMounted(() => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        currentUser.value = user;
      });

      // Add event listener to handle clicks outside the dropdown
      document.addEventListener('click', handleClickOutside);

      // Cleanup the subscription and event listener when component is destroyed
      return () => {
        unsubscribe();
        document.removeEventListener('click', handleClickOutside);
      };
    });

    const toggleDropdown = () => {
      showDropdown.value = !showDropdown.value;
    };

    const logout = async () => {
      const auth = getAuth();
      try {
        await signOut(auth);
        router.push('/login');
      } catch (error) {
        console.error("Error logging out:", error);
      }
    };

    return {
      showDropdown,
      currentUser,
      toggleDropdown,
      logout,
      dropdownContainer
    };
  }
}
</script>

<style scoped>
router-link {
  text-decoration: none;
}

router-link.active {
  font-weight: bold;
}

.navigation {
  background-color: #242424;
  min-height: 5dvh;
  padding-left: 10vw;
  padding-right: 10vw;
  font-family: 'Roboto';
}

/* Dropdown styles */
button:focus {
  outline: none;
}
</style>
